export const MARK_SRC = "/brand/ayndri-mark.png";

export const AyndriMark = ({ size = 40, className = "" }) => (
  <img src={MARK_SRC} width={Math.round(size * 1.153)} height={size} alt="" aria-hidden="true" className={`ayn-mark ${className}`} decoding="async" />
);

// variant: full (mark + wordmark + tagline) | compact (mark + wordmark); tone: light | dark
export const AyndriLogo = ({ variant = "full", tone = "light", markSize = 52, className = "", testId }) => (
  <span className={`ayn-logo ${tone} ${className}`} data-testid={testId}>
    <AyndriMark size={markSize} />
    <span className="ayn-text">
      <span className="ayn-word">AYNDRI</span>
      {variant === "full" && <span className="ayn-tag">EVENTS INTELLIGENCE</span>}
    </span>
  </span>
);
